export const getPreviewReportRoute = (reportId: number) => `/reports/${reportId}/preview`;
